exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.gray-route-log-container[data-v-fa8ca97a] {\n  padding-top: 8px;\n}\n.search-form[data-v-fa8ca97a] {\n  margin-bottom: 12px;\n}\n", ""]);

// exports
